var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTracking = function SvgTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.25 1.75a4.5 4.5 0 0 1 4.5 4.5c0 1.921-2.688 5.576-3.909 7.138a.75.75 0 0 1-1.182 0C4.438 11.827 1.75 8.171 1.75 6.25a4.5 4.5 0 0 1 4.5-4.5M19.75 12.324a4.5 4.5 0 0 1 4.5 4.5c0 1.921-2.688 5.576-3.909 7.138a.75.75 0 0 1-1.182 0c-1.221-1.562-3.909-5.217-3.909-7.138a4.5 4.5 0 0 1 4.5-4.5M6.25 16.75v3M6.25 22.75a1.5 1.5 0 0 0 1.5 1.5h1.5M12.25 24.25h1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeWidth: 2,
    d: "M6.25 6.625a.375.375 0 1 1 0-.75M6.25 6.625a.375.375 0 1 0 0-.75M19.75 17.2a.375.375 0 0 1 0-.75M19.75 17.2a.375.375 0 0 0 0-.75"
  })));
};
export default SvgTracking;